var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstallationNavLinkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 1.05L10 0L9 1.05L8 0L7 1.05L6 0L5 1.05L4 0L3 1.05L2 0L1 1.05L0 0V14L1 12.95L2 14L3 12.95L4 14L5 12.95L6 14L7 12.95L8 14L9 12.95L10 14L11 12.95L12 14V0L11 1.05ZM10.6667 11.963H1.33333V2.037H10.6667V11.963ZM2 9.1H10V10.5H2V9.1ZM2 6.3H10V7.7H2V6.3ZM2 3.5H10V4.9H2V3.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstallationNavLinkIcon);
export default __webpack_public_path__ + "static/media/installationNavLinkIcon.9655dcf8b0cd8ebdeeb2e89828955430.svg";
export { ForwardRef as ReactComponent };